import styled from 'styled-components'

export const TitleWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  > p {
    line-height: 21px;
    width: 310px;
  }
`